import l, { lazy as a } from "react";
import { TitlePage as o } from "./pages/TitlePage/TitlePage.js";
import { InfoPage as s } from "./pages/InfoPage/InfoPage.js";
import { providePage as t } from "./pages/pageSettingsProvider.js";
const d = a(() => import("./pages/UserAccountPage/UserAccountPage.js").then((e) => ({ default: e.UserAccountPage }))), i = a(() => import("./pages/UserProfilePage/UserProfilePage.js").then((e) => ({ default: e.UserProfilePage }))), n = a(() => import("./pages/UserOrdersPage/UserOrdersPage.js").then((e) => ({ default: e.UserOrdersPage }))), m = a(() => import("./pages/ViewOrderPage/ViewOrderPage.js").then((e) => ({ default: e.ViewOrderPage }))), f = a(() => import("./pages/UserRewards/UserRewardsDesktopCarrouselPage/UserRewardsDesktopCarrouselPage.js").then((e) => ({ default: e.UserRewardsDesktopCarrouselPage }))), k = a(() => import("./pages/UserRewards/UserRewardsCarrouselPage/UserRewardsCarrouselPage.js").then((e) => ({ default: e.UserRewardsCarrouselPage }))), c = a(() => import("./pages/LoyaltyPage/LoyaltyPage.js").then((e) => ({ default: e.LoyaltyPage }))), h = a(() => import("./pages/UserPaymentMethods/UserPaymentMethods.js").then((e) => ({ default: e.UserPaymentMethods }))), p = a(() => import("./pages/MyCashbackPage/MyCashbackPage.js").then((e) => ({ default: e.MyCashbackPage }))), u = a(() => import("./pages/StampCardsPage/index.js").then((e) => ({ default: e.StampCardDesktopCarrouselPage }))), y = a(() => import("./pages/StampCardsPage/index.js").then((e) => ({ default: e.StampCardsMobilePage }))), U = {
  userAccount: (e) => [{
    path: "/account",
    desktop: {
      left: {
        key: "account",
        element: t(d, e)
      },
      right: {
        element: !1
      }
    },
    mobile: {
      element: t(d, e)
    }
  }],
  userProfile: (e) => [{
    path: "/profile",
    desktop: {
      left: {
        key: "account",
        element: t(d, e.account)
      },
      right: {
        element: t(i, e.profile)
      }
    },
    mobile: {
      element: t(i, e.profile)
    }
  }],
  orders: (e, r) => [
    {
      path: "/orders",
      desktop: {
        left: {
          key: "ordersList",
          element: t(n, e)
        },
        right: {
          element: /* @__PURE__ */ l.createElement(s, { title: r("userOrders.info") })
        }
      },
      mobile: {
        key: "ordersList",
        element: t(n, e)
      }
    },
    {
      path: "/order/:id",
      desktop: {
        left: {
          key: "ordersList",
          element: t(n, e)
        },
        right: {
          element: t(m, e)
        }
      },
      mobile: {
        element: t(m, e)
      }
    }
  ],
  rewards: (e, r) => [
    {
      path: "/rewards",
      desktop: {
        left: {
          element: /* @__PURE__ */ l.createElement(o, { title: e.title || r("vouchers") })
        },
        right: {
          element: t(f, e)
        }
      },
      mobile: {
        element: t(k, e)
      }
    }
  ],
  loyalty: (e, r) => [
    {
      path: "/loyalty",
      desktop: {
        left: {
          element: /* @__PURE__ */ l.createElement(o, { title: e.title || r("loyaltyCard") })
        },
        right: {
          element: t(c, e)
        }
      },
      mobile: {
        element: t(c, e)
      }
    }
  ],
  paymentMethods: (e, r) => [
    {
      path: "/payment-methods",
      desktop: {
        left: {
          element: /* @__PURE__ */ l.createElement(o, { title: e.title || r("paymentMethods") })
        },
        right: {
          element: t(h, e)
        }
      },
      mobile: {
        element: t(h, e)
      }
    }
  ],
  myCashback: (e, r) => [
    {
      path: "/my-cashback",
      desktop: {
        left: {
          key: "cashbackList",
          element: t(p, e)
        },
        right: {
          element: /* @__PURE__ */ l.createElement(s, { title: r("userOrders.info") })
        }
      },
      mobile: {
        key: "cashbackList",
        element: t(p, e)
      }
    },
    {
      path: "my-cashback/order/:id",
      desktop: {
        left: {
          key: "cashbackList",
          element: t(p, e)
        },
        right: {
          element: t(m, e.viewOrder)
        }
      },
      mobile: {
        element: t(m, e.viewOrder)
      }
    }
  ],
  stampCards: (e, r) => [
    {
      path: "/stamp-cards",
      desktop: {
        left: {
          element: /* @__PURE__ */ l.createElement(o, { title: e.title || r("stampCards") })
        },
        right: {
          element: t(u, e)
        }
      },
      mobile: {
        element: t(y, e)
      }
    }
  ]
};
export {
  U as paths
};
//# sourceMappingURL=paths.js.map
